import { useEffect } from 'react';
import useSearchParams from '../../../utils/hooks/useSearchParams';
/**
 * Sets filters on mount based on query params for PE
 *
 * @param queryParams - query params
 * @param modelNames - list of product types to compare param with for error handling
 * @param mappedFilterType - list of filters and their items to compare with for error handling
 * @param dispatchFilter - function to trigger filter event
 * @returns false if it fails error checks, triggers dispatch function if succeeds
 */
export const getFiltersFromQueryParams = (queryParams, modelNames, mappedFilterType, dispatchFilter) => {
    queryParams.forEach((value, item) => {
        if (item === 'productType') {
            const targetModel = modelNames.find(modelObject => modelObject.modelName.toLowerCase() === value.toLowerCase());
            if (targetModel) {
                dispatchFilter({ type: 'RESET' });
                dispatchFilter({ type: 'ADD_ITEM', payload: { item: 'model', value: targetModel === null || targetModel === void 0 ? void 0 : targetModel.modelName } });
            }
        }
        if (!mappedFilterType.some(mappedFilterObject => mappedFilterObject.filterCategory.fields.items.some(filterObject => filterObject.filterName.value === value))) {
            return;
        }
        dispatchFilter({ type: 'RESET' });
        dispatchFilter({ type: 'ADD_ITEM', payload: { item, value } });
    });
};
const useFiltersFromQueryParams = ({ shouldUseQueryParams, modelNames, mappedFilterType, dispatchFilter }) => {
    const searchParams = useSearchParams();
    useEffect(() => {
        if (shouldUseQueryParams) {
            getFiltersFromQueryParams(searchParams, modelNames, mappedFilterType, dispatchFilter);
        }
    }, [searchParams.toString()]);
};
export default useFiltersFromQueryParams;
